<script setup>
import { storeToRefs } from 'pinia'
import Illustration1 from 'assets/illustrations/illu-01.svg?url'
import { useMessageStore } from '~/stores/messages'

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Markdown
const { $md } = useNuxtApp()
const deleteIntro = computed(() => $md.render(staticKeys.value?.account_form_delete_feedback_intro || ''))
</script>

<template>
    <SideBarWrapper class="feedback-note-container">
        <SideBarHeader>
            <SideBarMainHeadline :sidebar-main-headline-config="{ title: staticKeys?.account_form_delete_feedback_headline }" />

            <p class="sidebar-delete-feedback-text" v-html="deleteIntro" />
        </SideBarHeader>

        <img :src="Illustration1" :alt="staticKeys?.general_error_headline">
    </SideBarWrapper>
</template>

<style lang="scss">
.feedback-note-container {
    display: flex;
    flex-flow: row wrap;
    height: 100%;

    .side-bar-header {
        width: 100%;
    }

    img {
        width: 100%;
        margin-block-start: auto;
    }
}

.sidebar-delete-feedback-text {
    @include body2-medium;

    a {
        @include textlink;
    }
}

.sidebar-delete-feedback-form {
    margin-block-start: 40px;

    &::after {
        content: '';
        transition: opacity 400ms ease;
        opacity: 0;
    }

    &.is-submitting {
        @include form-is-submitting;
    }
}
</style>
